import { render, staticRenderFns } from "./d-profile-bookshelf-list.vue?vue&type=template&id=0ebd084e&scoped=true&"
import script from "./d-profile-bookshelf-list.vue?vue&type=script&lang=js&"
export * from "./d-profile-bookshelf-list.vue?vue&type=script&lang=js&"
import style0 from "./d-profile-bookshelf-list.vue?vue&type=style&index=0&id=0ebd084e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd084e",
  null
  
)

export default component.exports